import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment.development';
import { DataProfile, Profile } from '../shared/interfaces/profile.interface';
import { Observable, map } from 'rxjs';
import { IUid, Me } from '../shared/interfaces/Iuser.interface';

const HOST = environment.host;

@Injectable({
  providedIn: 'root'
})
export class UserInformationService {

  userProfile: DataProfile | undefined;
  constructor(private http: HttpClient) { }

  getUserProfile(id:any):Observable<DataProfile> {
    return this.http.get<Profile>(`${HOST}/api/user/user/${id}`).pipe(
      map(data =>  data.data)
    );
  }

  getUserId(): Observable<Me>{
    const url = `${HOST}/api`;
    return this.http.get<any>(url).pipe(
      map(resp => {
        if (!resp.meta) {
          throw new Error('Meta data is missing');
        }
        return resp.meta.links.me.meta.id;
      })
    );
  }

}
